// extracted by mini-css-extract-plugin
module.exports = {"section":"g_l","clients":"g_p","client":"g_q","clientImage":"g_r"};